<template>
  <div class="bg-gray-200 flex items-center py-3 pl-3 pr-[7px] rounded-2xl animate-pulse">
    <span class="block font-medium leading-[1.71] mr-1 text-base bg-gray-300 rounded w-24 h-6"></span>

    <div class="bg-gray-300 rounded-full w-6 h-6"></div>
  </div>
</template>
